import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';
import { outline } from './constants';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiTablePagination']
>['styleOverrides'] = {
  actions: () => ({
    button: {
      '&:not(:focus-visible)': {
        outline: 'none',
      },
    },
  }),
  // Move the "1–5 of 8" count before the spacer so it sits on the left, with
  // rows per page and the page buttons on the right.
  displayedRows: () => ({
    order: -1,
  }),
  root: () => ({
    // Rows per page dropdown
    '& .MuiSelect-select:focus-visible': {
      outline,
    },
  }),
};

const MuiTablePagination: Components<CssVarsTheme>['MuiTablePagination'] = {
  styleOverrides,
};

export default MuiTablePagination;
